import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { Button as ButtonMaterial } from "@material-ui/core";
import { twMerge } from "tailwind-merge";
import { ButtonBaseProps, appearances, variant } from "./common";
import React, { forwardRef } from "react";

const Button = forwardRef(
  (
    {
      children,
      startIcon: StartIcon,
      endIcon: EndIcon,
      appearance = "primary",
      type = "submit",
      size = "small",
      onClick,
      className,
      status = "default",
      classes,
    }: Omit<ButtonBaseProps, "appearance"> & {
      appearance?: "primary" | "secondary" | "link";
    },
    ref: React.Ref<HTMLButtonElement>
  ): React.ReactElement => (
    <ButtonMaterial
      size={size}
      disabled={status === "default" ? false : true}
      className={twMerge(
        appearances[appearance][0],
        appearances[appearance][1][status],
        "items-center justify-center border transition-colors",
        className
      )}
      classes={classes}
      onClick={onClick}
      endIcon={
        status === "loading" ? (
          <AiOutlineLoading3Quarters className="m-0 h-4 w-4 animate-spin p-0" />
        ) : (
          EndIcon
        )
      }
      startIcon={StartIcon}
      type={type}
      ref={ref}
      variant={variant[appearance]}
    >
      {children}
    </ButtonMaterial>
  )
);

if (process.env.NODE_ENV === "development") {
  Button.displayName = "Button";
}

export { Button };
